(function ($) {
  // Document Ready
  $(document).ready(function () {
    console.log("theme.js initiated");

    var isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;

    // Add nav height calculation
    var navheight = $("#main-nav").outerHeight(true);
    // document.documentElement.style.setProperty("--navHeight", navheight + "px");

    // Combine with existing window events
    var lastScrollTop = 0; // Variable to store the last scroll position
    const $mainNav = $("#main-nav"); // Cache the main navigation element

    $(window)
      .off("scroll resize")
      .on("scroll resize", function (event) {
        // Handle scroll events
        var scrolledFromTop = $(window).scrollTop();
        if (scrolledFromTop > 20) {
          $("body").addClass("scrolled");
        } else {
          $("body").removeClass("scrolled");
        }

        // Detect scroll direction
        if (scrolledFromTop > 60) {
          if (scrolledFromTop > lastScrollTop) {
            // Scrolling Down
            $("body").addClass("scrolling-down").removeClass("scrolling-up");
            $mainNav.attr({
              "aria-hidden": "true",
              inert: "true",
            });
          } else if (scrolledFromTop < lastScrollTop) {
            // Scrolling Up
            $("body").addClass("scrolling-up").removeClass("scrolling-down");
            $mainNav.attr("aria-hidden", "false").removeAttr("inert");
          }
          lastScrollTop = scrolledFromTop <= 0 ? 0 : scrolledFromTop; // For Mobile or negative scrolling
        } else {
          // Near the top of the page
          $("body").removeClass("scrolling-down scrolling-up");
          $mainNav.attr("aria-hidden", "false").removeAttr("inert");
        }

        // Update nav height on resize
        // if (event.type === "resize") {
        //   var navheight = $("#main-nav").outerHeight(true);
        //   document.documentElement.style.setProperty("--navHeight", navheight + "px");
        // }
      });

    // Menu Button Click Events
    // –> need to use the .off here to remove event handlers that were previously attached to elements
    // –> then we re-attach them
    $("#menu-btn")
      .off("click")
      .on("click", function () {
        const isExpanded = $("body").hasClass("menu-open");
        const navMenu = $("#navmenu");

        if (isExpanded) {
          // Close menu
          $("body").removeClass("menu-open");
          $("#menu-btn").attr("aria-expanded", "false");
          navMenu.prop("hidden", true);
        } else {
          // Open menu
          $("body").addClass("menu-open");
          $("#menu-btn").attr("aria-expanded", "true");
          navMenu.prop("hidden", false);
        }
      });

    $(".testimonials-carousel .owl-carousel").each(function () {
      $(this).owlCarousel({
        loop: true,
        autoplay: false,
        autoHeight: true,
        items: 1,
        dots: false,
        nav: true,
        navText: [
          '<span class="visuallyhidden">Click to view the previous</span><svg xmlns="http://www.w3.org/2000/svg" width="58.762" height="58.762" viewBox="0 0 58.762 58.762"><path d="M3.375,32.756A29.381,29.381,0,1,0,32.756,3.375,29.376,29.376,0,0,0,3.375,32.756Zm40.837-6.13a2.737,2.737,0,0,1,3.856,0,2.693,2.693,0,0,1,.791,1.921,2.74,2.74,0,0,1-.805,1.935L34.733,43.76a2.723,2.723,0,0,1-3.757-.085L17.458,30.2a2.727,2.727,0,0,1,3.856-3.856L32.77,37.912Z" transform="translate(62.137 -3.375) rotate(90)" fill="#a7cf70"/></svg>',
          '<span class="visuallyhidden">Click to view the next</span><svg xmlns="http://www.w3.org/2000/svg" width="58.762" height="58.762" viewBox="0 0 58.762 58.762"><path d="M3.375,32.756A29.381,29.381,0,1,0,32.756,3.375,29.376,29.376,0,0,0,3.375,32.756Zm40.837-6.13a2.737,2.737,0,0,1,3.856,0,2.693,2.693,0,0,1,.791,1.921,2.74,2.74,0,0,1-.805,1.935L34.733,43.76a2.723,2.723,0,0,1-3.757-.085L17.458,30.2a2.727,2.727,0,0,1,3.856-3.856L32.77,37.912Z" transform="translate(-3.375 62.137) rotate(-90)" fill="#a7cf70"/></svg>',
        ],
      });
    });

    /*****************************************************************
      Accordions
    *****************************************************************/

    if ($(".accordion").length) {
      $(".accordion-tab button").click(function (event) {
        var me = $(this),
          accordionTab = $(this).closest(".accordion-tab"),
          accordionContainer = $(this).closest(".accordion-container"),
          content = accordionTab.find("dd"),
          contentHeight = content.find(".content").outerHeight(true);

        console.log("accordionTab", accordionTab);
        console.log("accordionContainer", accordionContainer);
        console.log("content", content);
        console.log("contentHeight", contentHeight);

        // Toggle current accordion
        if (accordionTab.hasClass("open")) {
          // Close current accordion
          accordionTab.removeClass("open");
          me.attr("aria-expanded", "false");
          content.attr("aria-hidden", "true");
          content.css({
            "max-height": "0",
            position: "relative",
          });
        } else {
          // Close all accordions in the same container
          accordionContainer.find(".accordion-tab").each(function () {
            var tab = $(this);
            tab.removeClass("open");
            tab.find("button").attr("aria-expanded", "false");
            tab.find("dd").attr("aria-hidden", "true").css({
              "max-height": "0",
              position: "relative",
            });
          });

          // Open clicked accordion
          accordionTab.addClass("open");
          me.attr("aria-expanded", "true");
          content.attr("aria-hidden", "false");
          content.css({
            "max-height": contentHeight + "px",
            position: "relative",
          });
        }

        // GSAP Pin Fix -- Adjusted for accordion animation completion
        if (!isMobile) {
          //ScrollTrigger.refresh(true);
        }
      });

      // Update heights on window resize
      $(window).resize(function () {
        $(".accordion-tab.open").each(function () {
          var content = $(this).find("dd");
          var newHeight = content.find(".content").outerHeight(true);
          content.css("max-height", newHeight + "px");
        });

        // ScrollTrigger.refresh();
      });
    }

    /*****************************************************************
      Call in GSAP Animations
    ******************************************************************/
    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray(".fade-in-up").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 88%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          pin: false,
        },
      });
    });

    gsap.utils.toArray(".fade-in").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 88%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          pin: false,
        },
      });
    });

    /***************************************************
      Stat Counter Handlers
    /*****************************************************/
    if ($(".stats-section").length) {
      gsap.utils.toArray(".counter-value").forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            end: "bottom top",
            once: true,
            onEnter: () => {
              $(el)
                .prop("Counter", 0)
                .animate(
                  { Counter: $(el).attr("data-count") },
                  {
                    duration: 2000,
                    easing: "linear",
                    step: function (now) {
                      $(el).text(Math.floor(now));
                    },
                    complete: function () {
                      $(el).text(this.Counter);
                    },
                  }
                );
            },
          },
        });
      });
    }

    /*****************************************************************
      Marquee Image Section Animation
    ******************************************************************/
    if ($(".marquee-image-section").length) {
      gsap.utils.toArray(".marquee-image-section").forEach((sectionElement) => {
        const track = sectionElement.querySelector(".marquee-image-section__track");
        const trackWrapper = sectionElement.querySelector(".marquee-image-section__track-wrapper");

        if (track && trackWrapper) {
          const getScrollAmount = () => {
            // Calculate how much the track needs to scroll.
            // This is the total width of the track minus the visible width of its container.
            const scrollAmount = track.scrollWidth - trackWrapper.offsetWidth;
            return Math.max(0, scrollAmount); // Ensure it's not negative, so no scroll if not overflowing
          };

          gsap.to(track, {
            x: () => -getScrollAmount(),
            ease: "none",
            scrollTrigger: {
              trigger: sectionElement,
              start: "top bottom",
              end: "bottom top",
              scrub: 1,
              invalidateOnRefresh: true,
              // markers: true,
            },
          });
        }
      });

      // $(window).on('load', function() {
      //   ScrollTrigger.refresh();
      // });
    }

    /*****************************************************************
      Marquee Image Section - Mobile Carousel
    ******************************************************************/
    if ($(".marquee-carousel.owl-carousel").length) {
      $(".marquee-carousel.owl-carousel").owlCarousel({
        loop: true,
        autoplay: true,
        margin: 10,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        items: 1,
        stagePadding: 50,
        dots: false,
        nav: false,
      });

      $(".marquee-carousel.owl-carousel").on("changed.owl.carousel", function (event) {
        $(this).trigger("stop.owl.autoplay"); // resets the autoplay when
        $(this).trigger("play.owl.autoplay"); // user performs any actions
      });
    }

    /***************************************************
      Team Modal Handlers
    /*****************************************************/
    const openTeamModal = (event) => {
      const $button = $(event.currentTarget);
      const index = $button.data("index");
      const $memberBio = $(`.member-bio[data-index="${index}"]`);

      // Remove 'show' class from all bios
      $(".member-bio").removeClass("show");

      // Add 'show' class to the clicked bio
      $memberBio.addClass("show");

      // Add 'team-modal-active' class to body
      $("body").addClass("team-modal-active");
      $("#team-modal").attr("aria-hidden", "false").removeAttr("inert");
    };

    const closeTeamModal = () => {
      $("body").removeClass("team-modal-active");
      $("#team-modal").attr("aria-hidden", "true").attr("inert", "");

      // Remove 'show' class from all bios
      $(".member-bio").removeClass("show");
    };

    // Open team modal on button click
    $(".open-modal-btn").on("click", openTeamModal);

    // Close team modal on button click
    $(".close-modal-btn").on("click", closeTeamModal);

    // Close team modal on background click
    $(document).on("click", function (event) {
      if ($("body").hasClass("team-modal-active")) {
        const $target = $(event.target);
        if ($target.closest("#team-modal .container, .open-modal-btn").length === 0) {
          closeTeamModal();
        }
      }
    });

    // Close team modal on ESC key
    $(document).on("keydown", function (e) {
      if (e.key === "Escape" && $("body").hasClass("team-modal-active")) {
        closeTeamModal();
      }
    });

    /***************************************************
      Scroll to Next Section on Click
    /*****************************************************/
    $(".scroll-to-next-section").on("click", function (e) {
      e.preventDefault();
      const nextSection = $("#MainContent section").next();
      console.log("nextSection", nextSection);

      if (nextSection.length > 0) {
        $("html, body").animate({ scrollTop: $(nextSection).offset().top }, 600);
      }
    });
  });
})(jQuery);
